// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".calendar-layout[data-v-7b3a0acc]{margin-top:7px;display:grid;grid-template-columns:1fr;grid-column-gap:2rem;grid-row-gap:2rem;padding-bottom:80px}@media(min-width:1200px){.calendar-layout[data-v-7b3a0acc]{grid-template-columns:670px 470px;grid-column-gap:3rem;grid-row-gap:3rem}}", ""]);
// Exports
module.exports = exports;
